<template>
    <div>

        <div class="card dashcard mb-0">
            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo
                            :sync="true" 
                            @sync="load()"
                            v-model="filtro" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input 
                            placeholder="Informe o nome ou CPF do paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true"
                            @input="load()">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-secondary btn-sm" title="Ler pulseira do paciente." @click="toggle_bipagem_paciente()">
                                        <i class="fa-solid fa-barcode fa-fw"></i>
                                    </button>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="filtro && filtro.paciente">
                                    <button type="button" class="btn btn-outline-primary" @click="$root.perfil(filtro.paciente);">
                                        <i class="fa fa-id-badge" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <div v-if="camera_pulseira_paciente" style="max-width: 480px;">

                            <div id="qr-code-full-region"></div>

                            <qrcode-scanner
                                ref="qrcodepac"
                                :qrbox="250" 
                                :fps="10" 
                                style="width: 300px;"
                                @result="onScanPaciente"
                            />

                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados && dados.movs && dados.movs.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <template v-if="!( dados && dados.movs && dados.movs.length )">
            <az-empty-state icon="fa-solid fa-clipboard-list-check" msg="Nenhum item identificado para checagem." />
        </template>

        <template v-else>
            <div class="form-row mt-3">
                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between py-2" :class="'alert-dark'">
                            <div>
                                <div class="lead">
                                    Total
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(lista_ordenada, 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ totalizar(lista_ordenada, 'in_quantidade') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between alert-success py-2">
                            <div>
                                <div class="lead">
                                    Usado
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(lista_ordenada.filter(mov => mov.js_uso && mov.js_uso.uso > 0), 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ totalizar(lista_ordenada, 'js_uso.uso') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between alert-warning py-2">
                            <div>
                                <div class="lead">
                                    Devolução
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(lista_ordenada.filter(mov => mov.js_uso && mov.js_uso.devol > 0), 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ totalizar(lista_ordenada, 'js_uso.devol') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col col-12 col-md-3">
                    <div class="card h-100 mb-0 dashcard">
                        <div class="card-body d-flex justify-content-between alert-danger py-2">
                            <div>
                                <div class="lead">
                                    Pendente
                                </div>
                                <div class="small font-italic">
                                    Materiais: {{ distintos(lista_ordenada.filter(mov => mov.js_uso && ( mov.in_quantidade - mov.js_uso.uso - mov.js_uso.devol ) > 0), 'id_estoque_item') }}
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="display-4">
                                    {{ total_pendentes(lista_ordenada) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row mt-3">
                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        type="button-group"
                        :optionsList="opcoes_leitura"
                        optionsData="id"
                        v-model="tipo_bipagem" />
                </div>
                <div class="col col-12 col-md-9">
                    <selecao-material 
                        :barcode_only="true" 
                        @selecionado="selecionar_por_bipagem" />
                </div>
            </div>

            <template v-if="centros && centros.length > 1">
                <table class="table table-sm border-0 table-responsive mt-3 mb-0">
                    <tr>
                        <td>
                            <i class="fa-solid fa-location-dot" title="Centro de Custo"></i>
                        </td>
                        <td class="text-nowrap">
                            <a href="#" @click.prevent="centro.id_centro_custo == centro_selec ? centro_selec = '' : centro_selec = centro.id_centro_custo" v-for="(centro, icx) in centros" :key="icx">
                                <span class="badge mr-1" :class="centro.id_centro_custo == centro_selec ? 'badge-success' : 'badge-secondary'">
                                    {{ centro.st_sigla ? centro.st_sigla : centro.st_nome }}
                                </span>
                            </a>
                        </td>
                    </tr>
                </table>
            </template>

            <div v-if="suprimentos && items_para_devol.length" class="mt-3">
                <button type="button" class="btn btn-sm btn-outline-danger" @click="gerar_devolucao()">Gerar Devolução</button>
            </div>

            <template v-if="dados.devols && dados.devols.length">
                <div class="card mt-3">
                    <div class="card-header d-flex justify-content-between">
                        <a class="card-link" data-toggle="collapse" href="#collapseDevols" role="button" aria-expanded="false" aria-controls="collapseDevols">
                            Devoluções Realizadas
                        </a>

                        <div>
                            <span class="badge badge-secondary">
                                {{ dados.devols.length }}
                            </span>
                        </div>
                    </div>

                    <div class="card-body collapse" id="collapseDevols">

                        <table class="table table-hover bg-white table-sm small mt-2">
                            <thead>
                                <tr>
                                    <th>Material</th>
                                    <th>Lote</th>
                                    <th>Mov</th>
                                    <th>Solic</th>
                                    <th>CC</th>
                                    <th class="text-right">Qtde Devolvida</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(mov, imx) in dados.devols" :key="imx">
                                    <td>
                                        {{ mov.item.search }} 
                                        <span class="badge badge-secondary ml-1" :title="'Mov: ' + mov.id_estoque_movimentacao">#{{ mov.id_estoque_item }}</span>
                                    </td>
                                    <td><template v-if="mov.st_lote != 'Sem Lote'">{{ mov.st_lote }}</template></td>
                                    <td>#{{ mov.id_estoque_movimentacao }}</td>
                                    <td>{{ mov.st_doc }}</td>
                                    <td>{{ mov.centro ? mov.centro.st_sigla : '?' }}</td>
                                    <td class="text-right">{{ mov.in_quantidade }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>


            </template>

            <table class="table table-hover bg-white table-sm small mt-2">
                <thead>
                    <tr>
                        <th>Material</th>
                        <th>Lote</th>
                        <th>Mov</th>
                        <th>Solic</th>
                        <th>CC</th>
                        <th class="text-right">Qtde</th>
                        <th class="text-right">Usado</th>
                        <th class="text-right">Devolução</th>
                        <th class="text-right">Pendente</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(mov, imx) in lista_ordenada" :key="imx" :class="cor_linha(mov, 'table-')">
                        <td>
                            {{ mov.item.search }} 
                            <span class="badge badge-secondary ml-1" :title="'Mov: ' + mov.id_estoque_movimentacao">#{{ mov.id_estoque_item }}</span>
                        </td>
                        <td><template v-if="mov.st_lote != 'Sem Lote'">{{ mov.st_lote }}</template></td>
                        <td>#{{ mov.id_estoque_movimentacao }}</td>
                        <td>{{ mov.st_doc }}</td>
                        <td>{{ mov.centro ? mov.centro.st_sigla : '?' }}</td>
                        <td class="text-right">{{ mov.in_quantidade }}</td>
                        <td class="text-right">{{ mov.js_uso.uso }}</td>
                        <td class="text-right">{{ mov.js_uso.devol }}</td>
                        <td class="text-right">{{ mov.in_quantidade - (mov.js_uso.uso + mov.js_uso.devol) }}</td>
                    </tr>
                </tbody>
            </table>

        </template>

        <pre v-if="false">{{ dados }}</pre>

        <video id="beepElementPacienteId" src="/store-scanner-beep-90395.mp3" playsinline preload="auto" style="height: 10px;"></video> 

    </div>

</template>

<script>
import _ from 'lodash';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';

export default {
    data() {
        return { 
            filtro: { 
                periodo: "do", 
                paciente: "", 
            },
            dados: null, 
            tipo_bipagem: "U", 
            camera_pulseira_paciente: false, 
            centro_selec: "", 
            centros: null, 
        }
    },

    props: ['suprimentos'], 

    components: { 
        AzPeriodo,
        AzInput,
        SelecaoMaterial,
        AzEmptyState
    },

    computed: { 
        items_para_devol: function () { 
            return this.lista_ordenada.filter(mov => ( _.get(mov.js_uso, 'devol', 0) > 0 && !_.get(mov.js_uso, 'fim') ));
        },

        lista_ordenada: function () { 
            if ( !this.dados || !this.dados.movs ) {
                return [];
            }

            return _.orderBy(
                this.dados.movs.filter(mov => !this.centro_selec || mov.id_centro_custo == this.centro_selec), 
                [(mov) => ( ( _.get(mov.js_uso, 'uso', 0) + _.get(mov.js_uso, 'devol', 0) > 0 ) ? 1 : 2 ), 'item.search'], 
                ['asc', 'asc']
            );
        },

        opcoes_leitura: function () { 
            if ( this.suprimentos ) { 
                return [
                    { id: 'D', search: 'Devolução' },
                    { id: 'C', search: 'Cancelamento' }
                ];
            } else { 
                return [
                    { id: 'U', search: 'Uso' },
                    { id: 'C', search: 'Cancelamento' },
                ];
            }
        }
    },

    methods: { 
        gerar_devolucao () { 
            if ( !confirm('Confirma gerar a devolução dos itens selecionados?')) {
                return;
            }

            let solicgeral = this.$util.get_solic_geral();

            if ( solicgeral ) { 

                let info = { 
                    id_estoque_solicitacao: null, 
                    id_centro_custo: _.get(this.items_para_devol, '0.id_centro_custo', null),
                    marcacao: _.get(this.items_para_devol, '0.marcacao', null),
                    id_atendimento_procedimento: _.get(this.items_para_devol, '0.link.model.solicitacao.id_atendimento_procedimento', null),
                    devol: true, 
                    items: this.items_para_devol.map(item => ({ 
                        item: item.item,
                        lote: item.lote 
                            ? { item: item.lote }
                            : null, 
                        qtde: _.get(item.js_uso, 'devol', 0),
                    })), 
                };

                console.log('info', info);

                solicgeral.solicitar(
                    'D', 
                    info,
                    () => { 
                        this.load();
                    }
                );

            }

        },

        beep () { 
            const el = document.getElementById("beepElementPacienteId");
            el.play();
        },

        onScanPaciente (data) { 

            console.log(data);

            if ( data && data.text && !isNaN(data.text) ) { 

                let ref_pac = this.$refs.paciente;

                if ( ref_pac ) { 
                    ref_pac.search = 'P' + data.text;

                    this.$nextTick(() => {
                        ref_pac.onChange();
                    });
                }

                this.beep();

            }
        },

        toggle_bipagem_paciente () { 
            if ( this.camera_pulseira_paciente ) {
                let qrcode = this.$refs.qrcodepac;
                if ( qrcode ) {
                    if ( qrcode.html5QrcodeScanner.html5Qrcode.isScanning ) { 
                        qrcode.html5QrcodeScanner.html5Qrcode.stop();
                    }

                    this.$nextTick(() => { 
                        this.camera_pulseira_paciente = false;     
                    });
                    
                    return; 
                }
            }

            this.camera_pulseira_paciente = !this.camera_pulseira_paciente;
        },

        cor_linha (mov, prefixo) { 
            if ( ( mov.js_uso.uso + mov.js_uso.devol ) >= mov.in_quantidade ) {
                return prefixo + (mov.js_uso.devol > 0 ? 'warning' : 'success');
            }

            if ( mov.js_uso.devol > 0 ) {
                return prefixo + 'info';
            }

            if ( mov.js_uso.uso > 0 ) {
                return prefixo + 'primary';
            }

            return '';
        },

        atualizar_mov(mov) { 
            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'atualizar_mov_checagem',
                dados: mov
            });
        },

        selecionar_por_bipagem(item) { 
            if ( item && item.id_estoque_item ) { 
                let lote = _.get(item, 'info_lote.st_lote', 'Sem Lote');
                let mov = this.dados.movs.find(m => { 
                    if ( this.tipo_bipagem == 'C' ) { 
                        if ( !m.js_uso || !( m.js_uso.uso + m.js_uso.devol ) ) { 
                            return false; 
                        }
                    } else { 
                        if ( m.js_uso && ( ( m.js_uso.uso + m.js_uso.devol ) >= m.in_quantidade ) ) {
                            return false; 
                        }
                    }

                    return m.id_estoque_item == item.id_estoque_item && m.st_lote == lote; 
                });

                if ( mov && mov.js_uso ) { 

                    // Cancelamento de identificação

                    if ( this.tipo_bipagem == 'C' ) { 

                        if ( this.suprimentos && mov.js_uso.devol > 0 ) { 

                            mov.js_uso.devol--;

                            this.$toast.add({ 
                                severity: 'success',
                                summary: 'Cancelamento confirmado',
                                detail: `Material #${item.id_estoque_item} cancelado: \n${item.search}`,
                                life: 3000
                            });

                        } else if ( !this.suprimentos && mov.js_uso.uso > 0 ) { 

                            mov.js_uso.uso--;

                            this.$toast.add({ 
                                severity: 'success',
                                summary: 'Cancelamento confirmado',
                                detail: `Material #${item.id_estoque_item} cancelado: \n${item.search}`,
                                life: 3000
                            });

                        } else { 

                            this.$toast.add({ 
                                severity: 'error',
                                summary: 'Cancelamento indisponível',
                                detail: `Material #${item.id_estoque_item} não possível de cancelamento: \n${item.search}`,
                                life: 3000
                            });

                        }

                        this.atualizar_mov(mov);

                        return; 

                    }

                    //

                    if ( ( mov.js_uso.uso + mov.js_uso.devol ) >= mov.in_quantidade ) {
                        this.$toast.add({ 
                            severity: 'error',
                            summary: 'Uso excedido',
                            detail: `Material #${item.id_estoque_item} com uso já totalmente registrado: \n${item.search} \nLote: ${lote}`,
                            life: 3000
                        });
                        return;
                    }

                    let titulo; 

                    if ( this.tipo_bipagem == 'D' ) { 
                        mov.js_uso.devol++;
                        titulo = 'Devolução confirmada';
                    } else { 
                        mov.js_uso.uso++;
                        titulo = 'Uso confirmado';
                    }

                    this.atualizar_mov(mov);

                    this.$toast.add({ 
                        severity: 'success',
                        summary: titulo,
                        detail: `Material #${item.id_estoque_item} registrado: \n${item.search}`,
                        life: 3000
                    });

                } else { 

                    this.$toast.add({ 
                        severity: 'error',
                        summary: 'Atenção',
                        detail: `Material #${item.id_estoque_item} não localizado: \n${item.search} \nLote: ${lote}`,
                        life: 3000
                    });

                }

            }

        },

        distintos (lista, campo) { 
            return _.uniqBy(lista, campo).length;
        },

        totalizar (lista, campo) { 
            return _.sumBy(lista, campo);
        },

        total_pendentes (lista) { 
            return lista.reduce((acc, mov) => {
                if ( !mov.js_uso ) { 
                    return acc; 
                }
                return acc + (mov.in_quantidade - mov.js_uso.uso - mov.js_uso.devol);
            }, 0);
        },

        load() { 
            if ( !this.filtro.paciente ) { 
                this.dados = null; 
                this.centros = null;
                this.centro_selec = ""; 
                return; 
            }

            this.$util.load(this, { 
                service: 'estoque',
                func: 'carregar_consumo',
                parms: { 
                    ...this.filtro,
                },
                loadTo: res => { 
                    this.centros = _.orderBy(
                        _.uniqBy(res.movs.map(mov => mov.centro), 'id_centro_custo'),
                        'st_sigla'
                    );

                    this.centro_selec = ""; 

                    this.dados = { 
                        
                        movs: res.movs.map(mov => { 

                            if ( !mov.js_uso ) { 
                                mov.js_uso = { 
                                    uso: 0,
                                    devol: 0,
                                    pend: mov.in_quantidade,
                                };
                            }

                            return mov;

                        }),

                        devols: res.devols, 
                    };
                }
            });
        }
    },

    mounted() {
        if ( this.suprimentos ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Suprimentos", path: "/suprimentos/atendimento" },
                { name: "Checagem Consumo", path: "/suprimentos/checagem-consumo" },
            ]);

            this.tipo_bipagem = 'D';
        } else { 
            this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: "Checagem Consumo", path: "/assistencia/checagem-consumo" },
            ]);
        }

        if ( this.$refs.paciente ) { 
            this.$refs.paciente.$refs.input.focus();
        }
    }
}
</script>
